const renderMarker = (AMap, opts) => (context) => {
  const { labelRender, onClick } = opts
  const icon = context.data[0]?.icon
  if (icon) {
    context.marker.setIcon(
      new AMap.Icon({
        size: new AMap.Size(32, 32), // 图标尺寸
        image: icon, // Icon的图像
        imageSize: new AMap.Size(32, 32), // 根据所设置的大小拉伸或压缩图片
      })
    )
  }

  if (labelRender && context.data.length === 1) {
    context.marker.setLabel({
      offset: new AMap.Pixel(0, -5),
      content: labelRender(context.data[0].extData),
      direction: 'top',
    })
  }

  context.marker.setTop(true)
  context.marker.setClickable(true)
  if (onClick) {
    context.marker.on('click', () => {
      onClick({
        count: context.count,
        data: context.data.map((x) => x.extData),
      })
    })
  }
}

const ClusterMarkers = (
  opts = {
    gridSize: 60,
    maxZoom: 17,
    cacheKey: 'objectId',
  }
) => {
  const clear = (AMap, amap, layer) => () => {
    // amap.clearMap()
    layer.cache = {}
    if (layer.cluster) {
      layer.cluster.setData([])
    }
  }
  const render =
    (AMap, amap, layer) =>
    (data, config = {}, cacheFlag) => {
      const { cacheKey, gridSize, maxZoom } = opts
      const { icon } = config

      // 清除缓存
      if (cacheFlag && layer.cacheFlag !== cacheFlag) {
        layer.clear()
        layer.cacheFlag = cacheFlag
      }

      const renderData = data.filter((item) => !layer.cache[item[cacheKey]])

      if (renderData.length === 0) {
        console.log('[use amap]', '无需渲染')
        return
      }

      const markers = renderData.map((x) => ({
        lnglat: x.lnglat,
        extData: x,
        icon,
      }))

      if (layer.cluster) {
        layer.cluster.addData(markers)
      } else {
        layer.cluster = new AMap.MarkerCluster(amap, markers, {
          gridSize,
          maxZoom,
          renderMarker: renderMarker(AMap, config),
        })
      }

      renderData.forEach((item) => {
        layer.cache[item[cacheKey]] = item
      })
    }

  const setApis = (AMap, amap) => ({
    initClusterMarker: (layer) => {
      layer.cache = {}
      layer.clear = clear(AMap, amap, layer)
      layer.render = render(AMap, amap, layer)
    },
  })

  return {
    amapPlugins: ['AMap.MarkerCluster'],
    setApis,
  }
}

export default ClusterMarkers
